module.exports = __webpack_public_path__ + "static/media/sre-length.1e3ee1db.svg";